import React from 'react';

import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import { IconSortMapping } from './types/general';

export const priorityMapping: IconSortMapping = {
  high: {
    icon: <KeyboardDoubleArrowUpIcon fontSize='small' color='error' />,
    sortOrder: 1,
  },
  medium: {
    icon: <MoreHorizIcon fontSize='small' color='warning' />,
    sortOrder: 2,
  },
  low: {
    icon: <KeyboardDoubleArrowDownIcon fontSize='small' color='info' />,
    sortOrder: 3,
  },
};

export const riskAssessmentMapping: IconSortMapping = {
  high: {
    icon: <KeyboardDoubleArrowUpIcon fontSize='small' color='error' />,
    sortOrder: 1,
  },
  medium: {
    icon: <MoreHorizIcon fontSize='small' color='warning' />,
    sortOrder: 2,
  },
  low: {
    icon: <KeyboardDoubleArrowDownIcon fontSize='small' color='info' />,
    sortOrder: 3,
  },
};
